// extracted by mini-css-extract-plugin
export default {"CarModels":"CarModels_CarModels__vug9n","CarModels__new":"CarModels_CarModels__new__ZrOp2","CarModels__table":"CarModels_CarModels__table__xmiQG"};